<template>
  <div class="dashboard">
    <div class="main-content">
      <navbar-dashboard name="Billetera electrónica"></navbar-dashboard>

      <div class="ew-view">
        <page-header title="Monedero" subtitle="Saldo, recargas y movimientos de tu cuenta.">
          <router-link class="btn btn-primary" to="/prepaid/new">
            <i class="bi bi-plus-lg mr-1"></i> Recargar saldo
          </router-link>
        </page-header>

        <div class="ew-stats">
          <stat-card label="Saldo disponible" :value="formatCurrency(total_monedero)" icon="bi bi-wallet2" tone="navy" />
          <stat-card label="Ingresos" :value="formatCurrency(totalIncome)" icon="bi bi-arrow-down-left" tone="success" />
          <stat-card label="Gastos" :value="formatCurrency(totalExpense)" icon="bi bi-arrow-up-right" tone="danger" />
          <stat-card label="Pendientes" :value="formatCurrency(totalPending)" icon="bi bi-hourglass-split" tone="warning"
            hint="Recargas en proceso" />
        </div>

        <!-- Historial de Transacciones -->
        <div class="card ew-tx-card">
          <div class="ew-tx-header">
            <h2 class="ew-tx-title">Movimientos</h2>
            <div class="btn-group ew-segmented" role="group" aria-label="Filtrar movimientos">
              <button class="btn btn-sm" :class="{ active: filterType === 'all' }" @click="filterType = 'all'">Todos</button>
              <button class="btn btn-sm" :class="{ active: filterType === 'income' }" @click="filterType = 'income'">Ingresos</button>
              <button class="btn btn-sm" :class="{ active: filterType === 'expense' }" @click="filterType = 'expense'">Gastos</button>
            </div>
          </div>

          <div class="ew-tx-list">
            <div class="ew-tx" v-for="(p, i) in filteredPrepaids" :key="i">
              <div class="ew-tx-icon" :class="p.amount > 0 ? 'is-in' : (p.amount < 0 ? 'is-out' : 'is-zero')">
                <i :class="p.amount > 0 ? 'bi bi-arrow-down-left' : 'bi bi-arrow-up-right'"></i>
              </div>
              <div class="ew-tx-body">
                <div class="ew-tx-line">
                  <span class="ew-tx-name">{{ p.type }}</span>
                  <span class="badge" :class="p.status ? 'badge-success' : 'badge-warning'">
                    {{ p.status ? 'Pagado' : 'Pendiente' }}
                  </span>
                </div>
                <div class="ew-tx-meta">
                  <span>{{ formatDateTime(p.created_at) }}</span>
                  <span v-if="p.type != 'Pago Cargos adicionales' && p.type != (p.shipment ? 'Cargo' : 'Abono')">· {{ p.shipment ? 'Cargo' : 'Abono' }}</span>
                  <span v-if="p.shipment && p.shipment.number_guide">· Guía {{ p.shipment.number_guide }}</span>
                  <span v-if="p.shipment && p.shipment.carrier">· {{ p.shipment.carrier | carrierName }}</span>
                  <span v-if="p.numberOfOrder">· Pedido {{ p.numberOfOrder }}</span>
                </div>
              </div>
              <div class="ew-tx-amount" :class="p.amount > 0 ? 'text-success' : (p.amount < 0 ? 'text-danger' : 'text-muted')">
                {{ p.amount > 0 ? '+' : '' }}{{ formatCurrency(p.amount) }}
              </div>
            </div>
            <empty-state v-if="!filteredPrepaids || !filteredPrepaids.length" icon="bi bi-wallet2"
              title="Sin movimientos" text="Tus recargas y cargos aparecerán aquí." compact />
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<style scoped>
.ew-tx-card {
  padding: 0;
  overflow: hidden;
}

.ew-tx-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  padding: 16px 20px;
  border-bottom: 1px solid #eceef5;
}

.ew-tx-title {
  margin: 0;
  font-size: 1rem;
  font-weight: 700;
}

.ew-segmented {
  padding: 3px;
  background: #f1f3f9;
  border-radius: 10px !important;
}

.ew-segmented .btn {
  border: 0;
  border-radius: 7px !important;
  color: #4a5064;
  font-weight: 600;
}

.ew-segmented .btn.active {
  background: #fff;
  color: #031d7d;
  box-shadow: 0 1px 3px rgba(16, 24, 64, 0.12);
}

.ew-tx-list {
  max-height: 460px;
  overflow-y: auto;
}

.ew-tx {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 20px;
  border-bottom: 1px solid #f1f3f9;
}

.ew-tx:hover {
  background: #fafbfd;
}

.ew-tx-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 38px;
  height: 38px;
  border-radius: 10px;
  font-size: 1rem;
}

.ew-tx-icon.is-in {
  background: #e7f4ec;
  color: #15803d;
}

.ew-tx-icon.is-out {
  background: #fdecea;
  color: #d92d20;
}

.ew-tx-icon.is-zero {
  background: #f0f1f5;
  color: #6b7185;
}

.ew-tx-body {
  flex: 1;
  min-width: 0;
}

.ew-tx-line {
  display: flex;
  align-items: center;
  gap: 8px;
}

.ew-tx-name {
  color: #1c2030;
  font-weight: 600;
}

.ew-tx-meta {
  margin-top: 2px;
  color: #6b7185;
  font-size: 0.8rem;
}

.ew-tx-meta span + span {
  margin-left: 4px;
}

.ew-tx-amount {
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
</style>


<script>
import Navbar from './Header/Navbar'
import { mapGetters, mapMutations } from 'vuex'
import axios from 'axios'
import moment from 'moment'
import commons from '../commons'

export default {
  name: 'Addresses',
  data() {
    return {
      filterType: 'all', // estado del filtro
      user_id: '',
      prepaids: [],
      total_monedero: 0,
      isOpen: false,
      results: [],
      scroll: 0,
      isLoading: false,
      arrowCounter: -1,
    }
  },
  created() {
    this.user_id = localStorage.getItem('ew-user-id')
    this.getPrepaidsUser()
    this.setItemActive('prepaids')
  },
  mounted() {

  },
  beforeDestroy() {

  },
  methods: {
    ...mapMutations(['setItemActive']),
    formatCurrency(value) {
      return Number(value).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' });
    },
    formatDateTime(value) {
      if (value) {
        return moment(String(value)).format('DD/MM/YYYY HH:mm:ss')
      }
    },
    getPrepaidsUser() {
      axios
        .get(`${commons.apiURL}/api/v1/prepaid?user=${this.user_id}`)
        .then(response => {
          this.prepaids = response.data
          for (var i = 0; i < this.prepaids.length; i++) {
            if (this.prepaids[i].status == true) {
              this.total_monedero += parseFloat(this.prepaids[i].amount);
            }
          }
        })
        .catch(error => {
          console.error(error)
        })
    },
    removePrepaid(id) {
      axios
        .delete(`${commons.apiURL}/api/v1/prepaid/${id}`)
        .then(response => {
          if (response.status == 200) {
            this.getPrepaidsUser()
          }
        })
        .catch(error => {
          console.error(error)
        })
    },

  },
  computed: {
    filteredPrepaids() {
      if (this.filterType === 'all') return this.prepaids;
      if (this.filterType === 'income') {
        return this.prepaids.filter(p => !p.shipment || p.type === 'Abono');
      }
      if (this.filterType === 'expense') {
        return this.prepaids.filter(p => p.shipment && p.type !== 'Abono');
      }
      return this.prepaids;
    }, totalIncome() {
      return this.prepaids
        .filter(p => !p.shipment || p.type === 'Abono')
        .reduce((sum, p) => sum + Number(p.amount), 0);
    },
    totalExpense() {
      return this.prepaids
        .filter(p => p.shipment && p.type !== 'Abono')
        .reduce((sum, p) => sum + Math.abs(Number(p.amount)), 0);
    },
    totalPending() {
      return this.prepaids
        .filter(p => p.status === false)
        .reduce((sum, p) => sum + Math.abs(Number(p.amount)), 0);
    },
    ...mapGetters(['itemActive'])
  },
  components: {
    'navbar-dashboard': Navbar
  },
}
</script>



// WEBPACK FOOTER //
// src/components/ListPrepaid.vue